<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <div class="modal">
                <header class="modal-header">
                    <slot name="header">
                        {{title}}
                        <button type="button"
                                class="btn-close"
                                @click="close">
                            ×
                        </button>
                    </slot>
                </header>
                <section class="modal-body">
                    <slot name="body">
                        I'm the default body!
                    </slot>
                </section>
                <footer class="modal-footer">
                    <slot name="footer">
                        <button
                                type="button"
                                class="btn btn-primary"
                                @click="confirm">
                            {{confirmText}}
                        </button>
                        <button
                                type="button"
                                class="btn btn-cancel"
                                @click="close">
                            Annuller
                        </button>
                    </slot>
                </footer>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Modal",
        props: ['confirm-text','title'],
        methods: {
            close() {
                this.$emit('close');
            },
            confirm() {
                this.$emit('confirm');
            },
        },
    }
</script>

<style lang="scss">

    .modal-fade-enter,
    .modal-fade-leave-active {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity .2s ease
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal {
        background: #262A2F;
        box-shadow: 0 0 20px rgba(0, 0, 0, .3);
        overflow-x: auto;
        display: flex;
        flex-direction: column;
        min-width: 500px;

        .input-group {
            margin-bottom: 1rem;
            position: relative;


            span.ininput {
                position: absolute;
                left: 10px;
                top: 34px;
            }
            label {
                display: inline-block;
                margin-bottom: .5rem;
            }

            input {
                transition: ease .2s;
            }

            input[type=text] {
                display: block;
                background-color: #40444b;
                color: #a0a6b1;
                border: 1px solid #40444b;
                padding: .375rem .75rem;
                width: calc(100% - 1.5rem);
                border-radius: .25rem;
                font-size: 1rem;
                font-weight: 400;
                line-height: 1.5;
                &.ininput {
                    padding-left: 109px;
                    width: calc(100% - 1.5rem - 95px);
                }
            }

            input[type=date], input[type=time] {
                display: block;
                background-color: #40444b;
                color: #a0a6b1;
                border: 1px solid #40444b;
                padding: .375rem .75rem;
                width: calc(50% - 2rem);
                border-radius: .25rem;
                font-size: 1rem;
                font-weight: 400;
                line-height: 1.5;
            }

            &.checkbox {
                input {
                    position: absolute;
                    z-index: -1;
                    opacity: 0;

                    &:checked ~ label:before {
                        background-color: #131517;
                        border: 1px solid #131517;
                    }

                    &:checked ~ label:after {
                        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3E%3C/svg%3E");
                    }
                }

                label {
                    position: relative;
                    margin-bottom: 0;
                    vertical-align: top;
                    user-select: none;
                    margin-left: 1.8rem;

                    &:before {
                        background-color: #40444b;
                        color: #fff;
                        border-radius: .25rem;
                        transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
                        position: absolute;
                        top: 0;
                        left: -1.8rem;
                        display: block;
                        width: 1rem;
                        height: 1rem;
                        content: "";
                        border: 1px solid #40444b;
                    }

                    &:after {
                        transition: .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
                        background: no-repeat 50%/50% 50%;
                        position: absolute;
                        top: .05rem;
                        left: -1.75rem;
                        display: block;
                        width: 1rem;
                        height: 1rem;
                        content: "";
                        z-index: 5;
                    }
                }

                input:disabled ~ label:before {
                    background-color: transparent;
                    border: 1px solid #40444b;
                }

                input:disabled ~ label {
                    cursor: not-allowed;
                    color: darken(#a0a6b1, 25)
                }
            }

            .input-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            input:disabled {
                background-color: #262a2f;
                cursor: not-allowed;
                color: darken(#a0a6b1, 25)
            }
        }
    }

    .modal-footer {
        display: flex;
        justify-content: flex-start;
        padding: 15px;
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
        padding: 15px;
        font-size: 1.25rem;

        .btn-close {
            margin-top: -5px;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            font-weight: bold;
            color: #fff;
            background: transparent;
            outline: none;
        }
    }

    .modal-body {
        position: relative;
        padding: 20px 25px;
    }


    .btn {
        display: inline-block;
        font-weight: bold;
        text-align: center;
        vertical-align: center;
        user-select: none;
        padding: .375rem .75rem;
        font-size: 1rem;
        border-radius: .25rem;
        border: none;
        cursor: pointer;
        transition: ease .2s;
        outline: none;

        &:first-child {
            margin-right: 5px;
        }

        &.btn-primary {
            color: #fff;
            background: #007bff;
            border: 1px solid #007bff;
            border-radius: 2px;

            &:not(:disabled):hover {
                background: darken(#007bff, 10);
            }
        }

        &.btn-cancel {
            color: #fff;
            background: #40444b;
            border: 1px solid #40444b;
            border-radius: 2px;

            &:not(:disabled):hover {
                background: darken(#40444b, 5);
            }
        }

        &:disabled {
            cursor: not-allowed;
            border-color: darken(#40444b, 10);
            background: darken(#40444b, 10);
            color: darken(#fff, 60);
        }
    }

</style>